module.exports = __webpack_public_path__ + "img/73.efe0ca13.jpg";